import axios, { AxiosRequestConfig } from 'axios';
import Environment from '../../../environments/environment';
import {Interceptors} from './Interceptors';

export const urlApi = axios.create({
  baseURL: Environment.getUrl(),
});

export const scaApi = axios.create({
  baseURL: Environment.getScaUrl(),
});

export const fileApi = axios.create({
  baseURL: Environment.getFileUrl()
});

/**
 * Instância pública da API: usada em rotas abertas que devem funcionar tanto
 * com o usuário logado quanto deslogado. Não anexa Authorization e não força
 * o redirecionamento global para /logout em caso de 401/403.
 */
export const publicApi = axios.create({
  baseURL: Environment.getUrl(),
});

const attachToken = (request: AxiosRequestConfig) => {
  const token = sessionStorage.getItem('authToken');

  if (token) {
    if (!request.headers) request.headers = {};
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
};

urlApi.interceptors.response.use(
  (response) => Interceptors.responseInterceptorSuccess(response),
  (err) => Interceptors.responseInterceptorError(err));

urlApi.interceptors.request.use(
  (request) => {
    let req = Interceptors.requestInterceptor(request);
    req = attachToken(req); 
    return req;
  },
  (error) => Promise.reject(error)
);

fileApi.interceptors.response.use(
  (response) => Interceptors.responseInterceptorSuccess(response),
  (err) => Interceptors.responseInterceptorError(err));

fileApi.interceptors.request.use(
  (request) => {
    let req = Interceptors.requestInterceptor(request);
    req = attachToken(req);
    return req;
  },
  (error) => Promise.reject(error)
);

publicApi.interceptors.response.use(
  (response) => Interceptors.responseInterceptorSuccess(response),
  (err) => Interceptors.publicResponseInterceptorError(err)
);